import React, { useMemo, useRef } from 'react';
import { Meter, MeterProps, Rating } from './Meter';
import { NonIdealState } from '@blueprintjs/core';
import { selectDilDefinitionByName } from 'srs-middleware';
import { DefaultChartColorScales } from 'styles/chartColors';
import { Dimensions } from 'interfaces';
import d3 from 'd3';

/* const width = 475;
const height = 200;
const startAngle = 270;
const endAngle = 90;
const needleRadius = 15;
const arcWidth = 50;
const outerRadius = height - needleRadius * 4;
const innerRadius = outerRadius - arcWidth;
const needleHeight = (outerRadius + innerRadius) / 2;
const meterPercent = 0.82;
const meterMax = 10;
const meterX = width / 2;
const meterY = height - needleRadius * 3; */

/**
 * Wrapper for Meter.
 *
 * @param dimensions
 * @param widgetConfiguration
 * @returns {*}
 * @constructor
 */
export const MeterWrapper: React.FC<MeterWrapperProps> = ({ dimensions, widgetConfiguration: config, data }) => (
	<Meter dimensions={dimensions} widgetConfiguration={{ ...config, data }} />
);
interface MeterWrapperProps extends MeterProps {
	data: {
		score: number;
		denominator: number;
	};
}
